import React, { Component } from 'react';
import './scss/custom.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactLoading from 'react-loading';
var DateDiff = require('date-diff');

var loadTime = '';
export class Home extends Component {
    static displayName = Home.name;
    constructor(props) {
        super(props);
        this.state = { status: [], expandedRows: [], expandedServiceRows: [], loading: true, updatedOn: '', datasetStatus: [] };

        fetch('api/SubmissionStatus/GetAllProductsStatus')
            .then(response => response.json())
            .then(data => {
                this.setState({ status: data, loading: false, updatedOn: 'Updated now' });
            });
    }

    componentDidMount() {
        if (loadTime === '') {
            loadTime = new Date();
        }
        setInterval(
            () => this.loadData(),
            60000
        );

        setInterval(
            () => this.setElapsedTime(),
            10000
        );
    }

    loadData() {
        fetch('api/SubmissionStatus/GetAllProductsStatus')
            .then(response => response.json())
            .then(data => {
                this.setState({ status: data, loading: false, updatedOn: 'Updated now' });
            });

        loadTime = new Date();
        this.setElapsedTime();
    }

    setElapsedTime() {
        var timeNow = new Date();
        if (loadTime !== '' && loadTime !== '0') {
            var timeDiff = new DateDiff(timeNow, loadTime);
            if (timeDiff.seconds() !== 0) {
                this.setState({ updatedOn: 'Last Updated ' + timeDiff.seconds() + ' seconds ago' });
            }
            else {
                this.setState({ updatedOn: 'Updated now' });
            }
        }
        else {
            loadTime = new Date();
            this.setState({ updatedOn: 'Updated now' });
        }
    }

    getServiceRows = (status) => {

        let rows = [];
        var color = '';
        if (status.filter(m => m.status === 'Down').length > 0) {
            color = "fa-rcircle"
        }
        else if (status.filter(m => m.status === 'Unknown').length > 0) {
            color = "fa-acircle"
        }
        else if (status.filter(m => m.status === 'Available').length > 0) {
            color = "fa-gcircle"
        }

        const firstRow = (
            <FontAwesomeIcon icon="circle" className={color} />
        )

        rows.push(firstRow);

        return rows;
    }

    getStatus = (status, group) => {
        var row = status.filter(s => s.partitionKey === group);
        if (row != null) {
            return this.getServiceRows(row);
        }
    }

    renderStatusTable = (statuses) => {
        
        return (
            <div>
                <table className='submissionHeader'>
                    <tbody>
                        <tr>
                            <td className="tdFont innerStatusTD">
                                Products And Services
                    </td>
                            <td className="tdFont tdHeaderAlign innerStatusTD">Status</td>
                        </tr>
                    </tbody>
                </table>
                <table className='table'>
                    <tbody>
                        <tr>
                            <td className="tdFont"><a className="a-Product" id="SITREP" href="/SITREP"><span className="bm_span_spacing">SITREP</span></a>
                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'SITREP')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="AmbulanceDaily" className="a-Product" href="/ambulancestatus"><span className="bm_span_spacing">Ambulance Daily</span></a>

                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'AMBULANCE DAILY')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="Acute" className="a-Product" href="/acutestatus"><span className="bm_span_spacing">Acute Near Realtime</span></a>
                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'ACUTENEARREALTIME')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="AmbulanceReal" className="a-Product" href="/ambulancerealstatus"><span className="bm_span_spacing">Ambulance Near Realtime</span></a>
                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'AMBULANCENEARREALTIME')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="JointReporting" className="a-Product" href="/jointreporting"><span className="bm_span_spacing">Joint Reporting</span></a>

                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'Joint Reporting')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="CovidReporting" className="a-Product" href="/covidreporting"><span className="bm_span_spacing">Covid Reporting</span></a>

                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'Covid Reporting')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="MHECDS" className="a-Product" href="/mhecds"><span className="bm_span_spacing">MH ECDS</span></a>
                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'MHECDS')}</td>
                        </tr>
                        <tr>
                            <td className="tdFont"><a id="MHCRISIS" className="a-Product" href="/mhcrisis"><span className="bm_span_spacing">MH CRISIS</span></a>
                            </td>
                            <td className="tdHeaderAlign">{this.getStatus(statuses.serviceStatus, 'MHCRISIS')}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <div><ReactLoading type={"spokes"} color={"#000"} height={'7%'} width={'7%'} className="loading-gif" /></div>
            : this.renderStatusTable(this.state.status);

        return (
            <div>
                <div id="mainDiv">
                    <div className="btnrr"><span className="timeText">{this.state.updatedOn}</span></div>
                    <div className="headerAlign">{this.props.displayName}</div>
                    <div {...{ className: 'legend__align' }}>
                        <span>
                            <FontAwesomeIcon icon="circle" className="fa-gcircle" />
                            <span {...{ className: 'legend__font' }}> Good</span>
                        </span>
                        <span>
                            <FontAwesomeIcon icon="circle" className="fa-acircle" />
                            <span {...{ className: 'legend__font' }}> Degraded</span>
                        </span>
                        <span>
                            <FontAwesomeIcon icon="circle" className="fa-rcircle" />
                            <span {...{ className: 'legend__font' }}> Down</span>
                        </span>
                        <span>
                            <FontAwesomeIcon icon="info-circle" className="fa-icircle" />
                            <span {...{ className: 'legend__font' }}> Information</span>
                        </span>
                    </div>
                    {contents}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Home.js